export { default as WechatApp } from "./WechatApp";
